import AddButton from "../components/AddButton";
import Sidebar from "../components/Sidebar";
import RefreshButton from "../components/RefreshButton";
import React, {useEffect, useState} from "react";
import {privateApi} from "../api";
import axios from "axios";
import {toast} from "react-toastify";
import PriceInput from "../components/PriceInput";

type BrandResponse = {
    status: string;
    code: number;
    message: string;
    brands: BrandObject[];
}

type BrandObject = {
    id: string;
    name: string;
}

type DeviceResponse = {
    status: string;
    code: number;
    message: string;
    devices: DeviceObject[];
}

type DeviceObject = {
    id: string;
    model: string;
}

type ReplacementResponse = {
    status: string;
    code: number;
    message: string;
    replacements: ReplacementObject[];
    total: number;
}

type ReplacementObject = {
    id: string;
    description: string;
    price: number;
}

const PER_PAGE = 25;

function Replacement() {
    localStorage.setItem("focus", "ricambi")
    const [loading, setLoading] = useState(false);

    const [isModalOpen, setIsModalOpen] = React.useState(false);

    const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);

    const [brandFilterId, setBrandFilterId] = React.useState("");
    const [deviceFilterId, setDeviceFilterId] = React.useState("");
    const [brands, setBrands] = React.useState<BrandObject[]>([]);
    const [devices, setDevices] = React.useState<DeviceObject[]>([]);

    const [replacements, setReplacements] = React.useState<ReplacementObject[]>([]);

    // Add new replacement
    const [toAddDevices, setToAddDevices] = React.useState<DeviceObject[]>([]);
    const [addBrandId, setAddBrandId] = useState("");
    const [addDeviceId, setAddDeviceId] = useState("");
    const [addReplacementDescription, setAddReplacementDescription] = useState("");
    const [addReplacementPrice, setAddReplacementPrice] = useState("");

    // Edit replacement
    const [editSelectedReplacementId, setEditSelectedReplacementId] = React.useState("");
    const [editSelectedReplacementDescription, setEditSelectedReplacementDescription] = React.useState("");
    const [editSelectedReplacementPrice, setEditSelectedReplacementPrice] = React.useState("");

    const [page, setPage] = React.useState(0);
    const [total, setTotal] = useState(0);
    const totalPages = Math.ceil(total / PER_PAGE);

    const resetForm = () => {
        setAddBrandId("");
        setAddDeviceId("");
        setToAddDevices([]);
        setAddReplacementDescription("");
        setAddReplacementPrice("");
    }

    const loadReplacements = async () => {
        if (!brandFilterId || !deviceFilterId) return;
        setLoading(true);
        try {
            const response = await privateApi.get<ReplacementResponse>(`/cr-order-manager/v1/replacement?page=${page}&perPage=${PER_PAGE}&deviceId=${deviceFilterId}`);
            setReplacements(response.data.replacements);
            setTotal(response.data.total);
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        } finally {
            setLoading(false);
        }
    }

    const loadBrands = async () => {
        try {
            const response = await privateApi.get<BrandResponse>("/cr-order-manager/v1/deviceBrand");
            setBrands(response.data.brands);
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    }

    const loadDevices = async () => {
        if (!brandFilterId) return;
        try {
            const response = await privateApi.get<DeviceResponse>(`/cr-order-manager/v1/deviceBrand/${brandFilterId}/device`);
            setDevices(response.data.devices);
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    }

    const loadToAddDevices = async () => {
        if (!addBrandId) return;
        try {
            const response = await privateApi.get<DeviceResponse>(`/cr-order-manager/v1/deviceBrand/${addBrandId}/device`);
            setToAddDevices(response.data.devices);
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    }

    const saveNewReplacement = async () => {
        if (!addBrandId) return toast.error("Seleziona un brand");
        if (!addDeviceId) return toast.error("Seleziona un dispositivo");
        if (!addReplacementDescription) return toast.error("Inserisci una descrizione");
        if (!addReplacementPrice) return toast.error("Inserisci un prezzo");

        try {
            await privateApi.post("/cr-order-manager/v1/replacement", {
                deviceId: addDeviceId,
                description: addReplacementDescription,
                price: addReplacementPrice
            });
            toast.success("Ricambio aggiunto con successo");
            setIsModalOpen(false);
            resetForm();
            loadReplacements();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    }

    const deleteReplacement = async () => {
        try {
            await privateApi.delete(`/cr-order-manager/v1/replacement/${editSelectedReplacementId}`);
            toast.success("Ricambio eliminato con successo");
            setIsEditModalOpen(false);
            loadReplacements();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    }

    const editReplacement = async () => {
        if (!editSelectedReplacementDescription) return toast.error("Inserisci una descrizione");
        if (!editSelectedReplacementPrice) return toast.error("Inserisci un prezzo");

        try {
            await privateApi.patch(`/cr-order-manager/v1/replacement`, {
                replacementId: editSelectedReplacementId,
                deviceId: deviceFilterId,
                description: editSelectedReplacementDescription,
                price: editSelectedReplacementPrice
            });
            toast.success("Ricambio modificato con successo");
            setIsEditModalOpen(false);
            loadReplacements();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }

    }

    useEffect(() => {
        loadBrands();
        loadDevices();
    }, []);

    useEffect(() => {
        setDevices([]);
        setDeviceFilterId("");
        loadDevices();
    }, [brandFilterId]);

    useEffect(() => {
        setReplacements([]);
        loadReplacements();
    }, [brandFilterId, deviceFilterId]);

    useEffect(() => {
        setToAddDevices([]);
        loadToAddDevices();
    }, [addBrandId]);
    return (
        <>
            <Sidebar/>
            <main className="ml-64 p-6">
                <div className="flex items-center justify-between mb-6">
                    <h1 className="text-2xl font-bold">Ricambi</h1>
                    <div className="flex items-center gap-2">
                        <RefreshButton onClick={loadReplacements}/>
                        <AddButton
                            onClick={() => {
                                resetForm();
                                setIsModalOpen(true);
                            }}
                        />
                    </div>
                </div>

                {/* FILTERS */}
                <div className="mb-6 bg-white p-4 rounded-xl shadow">
                    <div className="flex items-center justify-between">
                        <h2 className="font-semibold">Filtri</h2>
                    </div>

                    {/*FILTER HEADER */}
                    <div className="border-t pt-3 flex items-center justify-between mb-3">
                        {/*ORDER BY*/}
                        <div className="flex items-center gap-2">
                            <label className="text-sm text-gray-600">Brand:</label>
                            <select
                                value={brandFilterId}
                                onChange={(e) => {
                                    setBrandFilterId(e.target.value);
                                    setPage(0);
                                }}

                                className="border rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-900">
                                <option key="" value="">-- Seleziona un brand --</option>
                                {brands.map((brand: BrandObject) => {
                                    return (<option key={brand.id} value={brand.id}>{brand.name}</option>)
                                })}
                            </select>

                            <label className="text-sm text-gray-600">Dispositivo:</label>
                            <select
                                value={deviceFilterId}
                                onChange={(e) => {
                                    setDeviceFilterId(e.target.value);
                                    setPage(0);
                                }}

                                className="border rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-900">
                                <option key="" value="">-- Seleziona un dispositivo --</option>
                                {devices.map((device: DeviceObject) => {
                                    return (<option key={device.id} value={device.id}>{device.model}</option>)
                                })}
                            </select>
                        </div>
                    </div>
                </div>

                <div className="space-y-6">
                    <div className="bg-white rounded-xl shadow p-5">

                        {/*Table*/}
                        <div className="overflow-x-auto">
                            <table className="w-full text-sm text-left">

                                <thead className="text-gray-500 border-b">
                                <tr>
                                    <th className="py-2">ID</th>
                                    <th className="py-2">Descrizione</th>
                                    <th className="py-2">Prezzo</th>
                                </tr>
                                </thead>

                                <tbody className="divide-y">
                                {loading ? (
                                    <tr>
                                        <td
                                            colSpan={4}
                                            className="py-6 text-center text-gray-500"
                                        >
                                            Caricamento...
                                        </td>
                                    </tr>
                                ) : replacements.length === 0 ? (
                                    <tr>
                                        <td
                                            colSpan={4}
                                            className="py-6 text-center text-gray-500"
                                        >
                                            Nessun componente trovato
                                        </td>
                                    </tr>
                                ) : (replacements.map((replacement: ReplacementObject) => (
                                    <tr key={replacement.id} className="hover:bg-gray-50"
                                        onClick={() => {
                                            setEditSelectedReplacementId(replacement.id);
                                            setEditSelectedReplacementDescription(replacement.description);
                                            setEditSelectedReplacementPrice(replacement.price.toString());
                                            setIsEditModalOpen(true);
                                        }}>
                                        <td className="py-2">{replacement.id}</td>
                                        <td className="py-2">{replacement.description}</td>
                                        <td className="py-2">€ {replacement.price}</td>
                                    </tr>
                                )))}

                                </tbody>

                            </table>
                        </div>

                        {/* PAGINATION */}
                        <div className="flex justify-between items-center mt-4">
                            <button
                                onClick={() => setPage((p) => Math.max(p - 1, 0))}
                                disabled={page === 0}
                                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                            >
                                Prev
                            </button>

                            <span className="text-sm">Pagina {page + 1} di {totalPages || 1}</span>

                            <button
                                onClick={() =>
                                    setPage((p) => Math.min(p + 1, totalPages - 1))
                                }
                                disabled={page >= totalPages - 1}
                                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                            >
                                Next
                            </button>
                        </div>

                    </div>
                </div>

                {isEditModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                        <div className="bg-white rounded-xl p-6 w-full max-w-md">
                            <h2 className="text-xl font-bold mb-4">
                                Modifica ricambio
                            </h2>

                            <div className="space-y-3">
                                <input className="w-full border p-2 rounded"
                                       placeholder="Descrizione"
                                       value={editSelectedReplacementDescription}
                                       onChange={(e) => {
                                           setEditSelectedReplacementDescription(e.target.value);
                                       }}/>
                                <PriceInput value={editSelectedReplacementPrice}
                                            onChange={setEditSelectedReplacementPrice}/>
                            </div>

                            <div className="flex justify-end gap-2 mt-4">
                                <button
                                    onClick={deleteReplacement}
                                    className="px-4 py-2 text-white bg-red-700 rounded"
                                >
                                    Elimina
                                </button>
                                <button
                                    onClick={() => {
                                        setIsEditModalOpen(false);
                                    }}
                                    className="px-4 py-2 bg-gray-200 rounded"
                                >
                                    Annulla
                                </button>

                                <button
                                    onClick={editReplacement}
                                    className="px-4 py-2 bg-blue-900 text-white rounded"
                                >
                                    Salva
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {isModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                        <div className="bg-white rounded-xl p-6 w-full max-w-md">
                            <h2 className="text-xl font-bold mb-4">
                                Nuovo ricambio
                            </h2>

                            <div className="space-y-3">
                                <select
                                    value={addBrandId}
                                    onChange={(e) => {
                                        setAddBrandId(e.target.value);
                                    }}

                                    className="w-full border p-2 rounded">
                                    <option key="" value="">-- Seleziona un brand --</option>
                                    {brands.map((brand: BrandObject) => {
                                        return (<option key={brand.id} value={brand.id}>{brand.name}</option>)
                                    })}
                                </select>
                                <select
                                    value={addDeviceId}
                                    onChange={(e) => {
                                        setAddDeviceId(e.target.value);
                                    }}

                                    className="w-full border p-2 rounded">
                                    <option key="" value="">-- Seleziona un dispositivo --</option>
                                    {toAddDevices.map((device: DeviceObject) => {
                                        return (<option key={device.id} value={device.id}>{device.model}</option>)
                                    })}
                                </select>
                                <input className="w-full border p-2 rounded"
                                       placeholder="Descrizione"
                                       value={addReplacementDescription}
                                       onChange={(e) => {
                                           setAddReplacementDescription(e.target.value);
                                       }}/>
                                <PriceInput value={addReplacementPrice} onChange={setAddReplacementPrice}/>
                            </div>


                            <div className="flex justify-end gap-2 mt-4">
                                <button
                                    onClick={() => {
                                        setIsModalOpen(false);
                                        resetForm();
                                    }}
                                    className="px-4 py-2 bg-gray-200 rounded"
                                >
                                    Annulla
                                </button>

                                <button
                                    onClick={saveNewReplacement}
                                    className="px-4 py-2 bg-blue-900 text-white rounded"
                                >
                                    Salva
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </main>
        </>
    )
}

export default Replacement;